import { useEffect } from "react";
import { useSelector } from "react-redux";
import { view } from "./CongressDetailsView";
import { useParams } from "react-router-dom";
import {
  logAnalyticEvent,
  getUrlParams,
  getISOFormattedDateTimeString,
} from "../../utils";
import {
  useGetConferenceDols,
  useGetConference,
  useGetReferredHandlesCount,
  useGetConferenceDolsByViews,
  useGetConferenceByCountry,
  useInfluencerStats,
  useTimeSegmentedTweets,
} from "../../store/queries/conference";
// import { useGetTweets } from "../../store/queries/tweets";

const MAX_RESULTS = 10;

import moment from "moment";
export const CongressDetails = ({ signUpClick }) => {
  const queryParams = getUrlParams(location.search);
  const { id } = useParams();
  const auth = useSelector((state) => state.auth.data);

  const { data: conference, isLoading: loadingConference } = useGetConference(
    id,
    true
  );

  const { data: influencerStats, isLoading: loadingInfluencerStats } =
    useInfluencerStats(id);

  const {
    data: prolificTweeters,
    isLoading: isLoadingProlificTweeters,
    isSuccess: isSuccessProlificTweeters,
  } = useGetConferenceDols({
    id: conference?.data?.id,
    // startDate: getISOFormattedDateTimeString(
    //   conference?.data?.monitorStartTime
    // ),
    // endDate: getISOFormattedDateTimeString(
    //   moment(conference?.data?.monitorEndTime)?.add(7, "day")?._d
    // ),
    maxResult: MAX_RESULTS,
  });

  const {
    data: influentials,
    isLoading: isLoadingInfluentials,
    isSuccess: isSuccessInfluentials,
  } = useGetReferredHandlesCount({
    id: conference?.data?.id,
    // startDate: getISOFormattedDateTimeString(
    //   conference?.data?.monitorStartTime
    // ),
    // endDate: getISOFormattedDateTimeString(
    //   moment(conference?.data?.monitorEndTime)?.add(7, "day")?._d
    // ),
    maxResult: MAX_RESULTS,
  });

  const {
    data: dolsByViews,
    isLoading: isLoadingDolsByViews,
    isSuccess: isSuccessDolsByViews,
  } = useGetConferenceDolsByViews({
    id: conference?.data?.id,
    // startDate: getISOFormattedDateTimeString(
    //   conference?.data?.monitorStartTime
    // ),
    // endDate: getISOFormattedDateTimeString(
    //   moment(conference?.data?.monitorEndTime)?.add(7, "day")?._d
    // ),
    maxResult: MAX_RESULTS,
  });

  const { data: conferenceByCountry, isLoading: loadingConferenceByCountry } =
    useGetConferenceByCountry({
      id: conference?.data?.id,
      // startDate: getISOFormattedDateTimeString(
      //   conference?.data?.monitorStartTime
      // ),
      // endDate: getISOFormattedDateTimeString(
      //   moment(conference?.data?.monitorEndTime)?.add(7, "day")?._d
      // ),
    });

  const { data: timeSegmentedTweets, isLoading: loadingTimeSegmentedTweets } =
    useTimeSegmentedTweets({
      tagId: conference?.data?.tagId,
      parentTagId: conference?.data?.parentTagId,
      startDate: getISOFormattedDateTimeString(
        conference?.data?.monitorStartTime
      ),
      endDate: getISOFormattedDateTimeString(conference?.data?.monitorEndTime),
      originalOnly: false,
      includeReplies: false,
      segment: "DAY",
    });

  const formatTimeData = (data) => {
    if (!data) return [];

    return data.map((item) => {
      return {
        date: moment(item.timesegment).format("MM/DD"),
        value: item.count,
      };
    });
  };

  useEffect(() => {
    scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (conference?.data) {
      logAnalyticEvent(
        "Landing - Top influencers",
        {
          page: "Conference",
          name: conference?.data?.primaryName,
        },
        auth?.id || queryParams?.u || null,
        auth?.displayName || queryParams?.n || null,
        auth?.email || queryParams?.e || null,
        auth?.createdAt || null,
        auth?.preferences?.filter((p) => p.preferenceName === "UserType")?.[0]
          ?.preferenceStringValue ||
          queryParams?.t ||
          "MEDICAL",
        null
      );
    }
  }, [conference?.data]);

  const getTop6Countries = (data) => {
    if (!data) return [];

    const sortedData = [...data].sort((a, b) => b.value - a.value);

    let top6 = sortedData
      .filter((item) => item.country.toLowerCase() !== "undetermined")
      .slice(0, 6);
    // Calculate sum of remaining values plus undetermined
    const otherSum = sortedData.reduce((sum, item, index) => {
      if (index >= 6 || item.country.toLowerCase() === "undetermined") {
        return sum + item.count;
      }
      return sum;
    }, 0);

    // Add "Other" category if there are remaining values
    if (otherSum > 0) {
      top6.push({
        country: "Other",
        count: otherSum,
        countrycode: "xx",
      });
    }

    return top6;
  };

  const conferenceTop6ByCountry = getTop6Countries(conferenceByCountry?.data);

  return view({
    signUpClick,
    isAdmin: auth?.mwRole === "ADMIN",
    influentials: {
      data: influentials?.data,
      isLoading: isLoadingInfluentials,
      isSuccess: isSuccessInfluentials,
    },
    prolificTweeters: {
      data: prolificTweeters?.data,
      isLoading: isLoadingProlificTweeters,
      isSuccess: isSuccessProlificTweeters,
    },
    highestImpressions: {
      data: dolsByViews?.data,
      isLoading: isLoadingDolsByViews,
      isSuccess: isSuccessDolsByViews,
    },
    conference: conference?.data,
    conferenceByCountry: conferenceTop6ByCountry,
    loadingConferenceByCountry,
    influencerStats: influencerStats?.data,
    loadingInfluencerStats,
    timeSegmentedTweets: formatTimeData(
      timeSegmentedTweets?.data?.slice(0, 23)
    ),
    loadingTimeSegmentedTweets,
  });
};
